import { CheckIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

interface LoginResetSentStateProps {
  email: string;
  onBackToSignIn: () => void;
}

export default function LoginResetSentState({
  email,
  onBackToSignIn,
}: LoginResetSentStateProps) {
  const { t } = useTranslation(["auth"]);
  return (
    <div className="py-4 text-center">
      <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full border border-[color:color-mix(in_srgb,var(--primary)_18%,transparent)] bg-[color:color-mix(in_srgb,var(--primary)_12%,var(--card))] text-[var(--primary)]">
        <CheckIcon aria-hidden="true" className="h-7 w-7" />
      </div>
      <h3 className="text-2xl font-semibold tracking-tight text-[var(--foreground)]">
        {t("auth:reset.checkEmail")}
      </h3>
      <p className="mt-3 text-sm leading-6 text-[var(--muted-foreground)]">
        {t("auth:reset.sentTo", { email })}
      </p>
      <Button
        variant="outline"
        size="lg"
        onClick={onBackToSignIn}
        data-test="login-reset-back"
        className="mt-6"
      >
        {t("auth:reset.backToSignIn")}
      </Button>
    </div>
  );
}
